import React, { useCallback } from 'react';
import EditorImage from '@wix/da-ds/pkg/Icons/24x24/EditorImage';
import { getStoredCallback, isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
export const useHandleDeviationClick = (editor)=>{
    const handleClick = useCallback(()=>{
        const onSelectMedia = getStoredCallback(editor, 'onSelectMedia');
        onSelectMedia && onSelectMedia((deviations)=>{
            if (deviations.length > 0) {
                editor.chain().focus().daDeviationAddDeviation(deviations[0]).run();
            }
        }, {});
    }, [
        editor
    ]);
    return handleClick;
};
const Deviation = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    const handleClick = useHandleDeviationClick(editor);
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'deviation')) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        tooltipText: t('button.deviation.tooltip'),
        "aria-label": t('button.deviation.tooltip'),
        icon: EditorImage,
        onClick: handleClick
    });
};
Deviation.displayName = 'Deviation';
export default Deviation;

//# sourceMappingURL=Deviation.js.map